import { IFMapImage } from "01Data/DataTypes";
import { Signal } from "99Tools/useModel";
import CancelIcon from "@mui/icons-material/Cancel";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import { Button, DialogActions, styled } from "@mui/material";
import { useRef } from "react";
import { NoteText } from "./Styles";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export const MapReader = ({
  entity,
  redraw,
}: {
  entity: IFMapImage;
  redraw: Signal;
}) => {
  const ref = useRef<any>();

  const ReadFile = (e: any) => {
    e.preventDefault();
    const fileInfo = e.target.files[0];
    if (!fileInfo) {
      // キャンセル時
      return;
    }
    if (
      !fileInfo.type.match("application/pdf") &&
      !fileInfo.type.match("image/jpeg") &&
      !fileInfo.type.match("image/png") &&
      !fileInfo.type.match("image/bmp")
    ) {
      entity.setError(
        fileInfo,
        "ファイルは PDF/JPEG/PNG/BMP 形式から選択してください。"
      );
      redraw();
      return;
    }
    try {
      // 読み込み
      const reader = new FileReader();
      reader.onloadend = () => {
        const data = Array.from<number>(
          new Uint8Array(reader.result as ArrayBuffer)
        );
        let str = "";
        for (let i = 0; i < data.length; i += 1024) {
          str += String.fromCharCode.apply(null, data.slice(i, i + 1024));
        }
        entity.clear();
        entity.setData(window.btoa(str));
        entity.setFileName(fileInfo.name);
        entity.setFileExtension(
          fileInfo.name.slice(fileInfo.name.lastIndexOf("."))
        );
        redraw();
      };
      reader.readAsArrayBuffer(fileInfo);
    } catch (err: any) {
      entity.setError(err, "画像ファイルの読み込みに失敗しました。");
      redraw();
    }
  };

  const handleCancelFile = () => {
    entity.clear();
    if (ref.current) {
      // VisuallyHiddenInputのvalueを初期化
      ref.current.value = "";
    }
    redraw();
  };

  return (
    <>
      <NoteText>詳細場所</NoteText>
      <DialogActions>
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          {entity.getFileName() === "" ? (
            <></>
          ) : (
            <div
              style={{
                display: "flex",
                gap: "5px",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              {entity.getFileName()}
              <CancelIcon
                style={{ color: "red", cursor: "pointer" }}
                onClick={handleCancelFile}
              />
            </div>
          )}
          <Button
            component="label"
            variant="contained"
            startIcon={<FileOpenIcon />}
          >
            選択…
            <VisuallyHiddenInput
              type="file"
              onChange={ReadFile}
              accept="application/pdf,image/jpeg,image/png,image/bmp"
              ref={ref}
            />
          </Button>
        </div>
      </DialogActions>
    </>
  );
};
